import React from 'react';
import PolicyTable from '../components/PolicyTable';
import { usePolicies } from '../context/PoliciesContext';

const PolicyTablePage = () => {
  const { policies } = usePolicies();

  if (policies.length === 0) {
    return (
      <div className="space-y-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Policy Table</h1>
          <p className="text-gray-600">Detailed view of all policies and their payment schedules</p>
        </div>
        
        <div className="card text-center py-12">
          <div className="text-gray-500 mb-4">
            <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Policies Available</h3>
          <p className="text-gray-600 mb-4">
            Upload documents in the Dashboard to start analyzing policies
          </p>
          <a 
            href="/dashboard" 
            className="inline-flex items-center px-4 py-2 bg-enpact-red text-white rounded-lg hover:bg-enpact-red-dark transition-colors duration-200"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Policy Table</h1>
        <p className="text-gray-600">Detailed view of all policies and their payment schedules</p>
      </div>
      
      <PolicyTable policies={policies} />
    </div>
  );
};

export default PolicyTablePage;
